import { data, Link, useNavigate } from 'react-router-dom';
import './login.css';
import { useState } from 'react';

export default function Login() {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const [inCorrectEmail, setInCorrectEmail] = useState(false);
    const [emailId, setEmailId] = useState('');
    const navigate = useNavigate();

    function isValidEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    function handleOTP() {
        if (!isValidEmail(emailId)) {
            setInCorrectEmail(true);
        } else {
            setInCorrectEmail(false)
            const dataToSend = {
                userId: emailId
            }
            navigate('/otp-verification', {state:{emailId}});
            fetch(`${BACKEND_URL}/login`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                    'content-type':'application/json',
                },
                body:JSON.stringify(dataToSend)
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data)            
                }).catch((error) => {
                    console.log(error)
                    alert('Error Occured!')
            })
            
        }
    }

    return (
        <div className='login-box'>
            <div style={{display:'flex', justifyContent:'center'}}>
                <img src='ontimeurban-cropped.jpg' alt='logo' className='login-logo'/>
            </div>
            <div className='login-bottom-box'>
                <p className='login-heading'>Welcome to OnTimeUrban</p>
                <input
                    type='text'
                    placeholder='Enter Email ID'
                    className='phone-input-login'
                    style={{padding:'0px 10px', borderRadius:'5px'}}
                    value={emailId}
                    onChange={(e) => setEmailId(e.target.value)}
                />
                {
                    inCorrectEmail && <p style={{marginTop:'5px', marginBottom:'5px', color:'red'}}>Incorrect Email ID</p>
                }
                <div className='login-otp-btn' onClick={handleOTP}>
                    Get OTP
                </div>
                <p style={{textAlign:'center', fontSize:'12px'}}>By continuing, you agree to our <Link to='/terms-and-conditions' style={{textDecoration:'none', color:'#2c5f2d'}}>Terms&Conditions</Link> and <Link to='/privacy-policy' style={{textDecoration:'none', color:'#2c5f2d'}}>PrivacyPolicy</Link></p>
            </div>
        </div>
    );
}